import * as React from "react";
import { Stack } from "@mui/material";
import logo from "@/assets/images/logo_white.svg";

export const IconLogo = (): React.JSX.Element => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
    <img width={211} src={logo} alt="logo" />
  </Stack>
);
